import {Component, Input, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, HostListener,
     OnChanges, SimpleChanges, ElementRef, ViewChild} from '@angular/core';
import {FormViewField} from '../../domain/form-view-field';
import {FormControl} from '@angular/forms';
import {MatDialog} from '@angular/material';
import {FieldValueModalComponent} from '../field-value-modal/field-value-modal.component';
import { defaultValueValidator } from '../form-view-detail/form-view-detail.component';
import { NoopScrollStrategy, BlockScrollStrategy } from '@angular/cdk/overlay';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
    selector: 'app-form-view-field',
    templateUrl: './form-view-field.component.html',
    styleUrls: ['./form-view-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})


export class FormViewFieldComponent implements OnInit {

    @Input('field') formField: FormViewField = null;

    @Input('control') control: FormControl = null;

    @ViewChild('editableField') editableField: ElementRef;

    dynamicText: string[] = [];

    skiped = false;

    focused = false;

    editingMode = false;

    pristine = true;

    invalid = false;

    defaultText = "campo a completar";

    empty = true;

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        const text = this.formField.placeholder.replace('{@}', '||[replace-me]||')
                                .replace(/(\ ){2}/g, "&nbsp;&nbsp;&nbsp;") // caracteres en blanco
        this.dynamicText = text.split('||');

        this.editingMode = this.control != null;

        this.cd.markForCheck();
    }

    onSkippedChange() {
        this.skiped = !this.skiped;
        this.skiped ? this.control.disable() : this.control.enable();
        this.cd.markForCheck();
    }

    onFocus() {
        setTimeout(() => {
            this.focused = true;
            this.pristine = false;
            if(this.control.value === this.defaultText){
                this.control.setValue("");
            }
            this.cd.markForCheck();
        },0)
    }

    onFocusOut() {
        this.focused = false;
        this.control.setValue(this.getFormattedValue());
        if(this.control.value.length === 0)
            this.empty = true;
        this.invalid = this.control.value === this.defaultText;
        this.cd.markForCheck()
    }

    checkValueAfterEmpty(){
        this.empty = this.getFormattedValue() === 0;
    }

    getFormattedValue() {
        return this.editableField.nativeElement.innerHTML.toString().replace(/&nbsp;/g, " ");
    }

    /* evita copiar html y otros tags de formato cuando el texto es de un pagina web o Word */
    onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const text = event.clipboardData.getData("text/plain");
        document.execCommand("insertHTML", false, text);
    }

}



// WEBPACK FOOTER //
// ./src/app/form-views/components/form-view-field/form-view-field.component.ts